import { useIsFocused } from '@react-navigation/native'
import { StackScreenProps } from '@react-navigation/stack'
import { useCallback, useEffect, useState } from 'react'
import { ScreenWrapper } from '../../../@ui/containers/grid/screen.wrapper'
import { useGlobalStyles } from '../../../contexts/global-styles.provider'
import { ContributionStatus } from '../../../generated/graphql'
import { ReplayNavigatorParams } from '../../../navigation/types'
import { ContributionList } from '../contributions/components/contribution.list'
import { Contribution } from '../../../generated/graphql'
import { useReplayApi } from '../../../services/snapshots/replay-api.hook'
import { ContributionFilter } from '../contributions/types'
import { IconButton } from 'react-native-paper'
import Row from '../../../@ui/containers/grid/row'
import { useTheme } from '../../../hooks/theme.hook'

export function ReplayClusterContributionsScreen({
  route,
  navigation,
}: StackScreenProps<ReplayNavigatorParams, 'ReplayClusterContributions'>) {
  const { clusterId } = route.params
  const theme = useTheme()
  const isFocused = useIsFocused()
  const globalStyles = useGlobalStyles()
  const { clusterService, tick } = useReplayApi()
  const [filter, setFilter] = useState<ContributionFilter>({
    status: 'All',
    type: 'All',
  })
  const [contributions, setContribution] = useState<Contribution[]>([])

  const refresh = useCallback(
    (filter: ContributionFilter) => {
      const contributions = clusterService.getClusterContributions(
        clusterId,
        filter
      )
      // This oen will not being display
      setContribution(
        contributions.filter(
          (contribution) =>
            contribution.status != ContributionStatus.Cancelled &&
            contribution.status != ContributionStatus.Censured
        )
      )
    },
    [clusterService, clusterId]
  )

  useEffect(() => {
    refresh(filter)
  }, [tick, refresh, filter, isFocused])

  const handleFilterChange = (type: any, status: any) => {
    setFilter({ type, status })
  }

  return (
    <ScreenWrapper
      style={{ ...globalStyles.pageContainer, padding: theme.spacing(4) }}
    >
      <Row alignItems="center" columnGap={4}>
        <IconButton
          mode={'outlined'}
          icon="arrow-left"
          onPress={() => navigation.goBack()}
        />
      </Row>
      <ContributionList
        contributions={contributions}
        status={filter.status}
        type={filter.type}
        readonly={true}
        onFilterChange={handleFilterChange}
        onContributionPress={(contribution) => {
          navigation.navigate('ReplayContribution', {
            contributionId: contribution.id,
          })
        }}
      />
    </ScreenWrapper>
  )
}
export default ReplayClusterContributionsScreen
